import React, { useEffect, useState } from 'react'
import { Button } from '@mui/material'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import { useNavigate } from '@reach/router'
import Layout from '../layout/Layout'
import Footer from '../footer/FooterBlack'
import { fetchApps } from '../account/AccountAPI'
import vocalnetImage from '../../images/pc/vocalnet.png'
import drumnetImage from '../../images/pc/drumnet.jpg'
import classes from './Promo.module.scss'

const products = [
  {
    appId: 'VocalNet',
    name: 'VocalNet',
    image: vocalnetImage,
    description: 'Clone and transform voices in real time.',
  },
  {
    appId: 'DrumNet',
    name: 'DrumNet',
    image: drumnetImage,
    description: 'Generate drum samples with infinite variations.',
  },
]

const formatPrice = price => {
  if (price === undefined || price === null || price === '') {
    return ''
  }

  return `$${price}`
}

const getDiscount = price => {
  if (price === undefined || price === null || price === '') {
    return ''
  }

  const discount = ((99 - Number(price)) / 99) * 100
  return `${Math.round(discount / 10) * 10}% off`
}

const Promo = () => {
  const navigate = useNavigate()
  const [prices, setPrices] = useState({})

  useEffect(() => {
    const loadPrices = async () => {
      try {
        const apps = await fetchApps({})
        const nextPrices = {}
        products.forEach(product => {
          const app = apps.find(item => item.appId === product.appId)
          if (app) {
            nextPrices[product.appId] = app.price
          }
        })
        setPrices(nextPrices)
      } catch (e) {
        console.error('Error fetching promo prices:', e)
      }
    }

    loadPrices()
  }, [])

  return <Layout title="Spring Sale - Session Loops">
    <main className={classes.root}>
      <section className={classes.hero}>
        <div className={classes.copy}>
          <p className={classes.eyebrow}>Spring Sale</p>
          <h1>VocalNet and DrumNet</h1>
          <p className={classes.description}>Save up to 50% on lifetime licenses before May 12, 2026 at 9:00 AM EST.</p>
        </div>
      </section>

      <section className={classes.products}>
        {products.map(product => <article className={classes.product} key={product.appId}>
          <div className={classes.media}>
            <img src={product.image} alt={product.name} />
          </div>
          <div className={classes.productBody}>
            <h2>{product.name}</h2>
            <p>{product.description}</p>
            <Button
              variant="contained"
              className={classes.buyButton}
              startIcon={<ShoppingCartIcon />}
              onClick={() => navigate(`/account/app-buy?app-id=${product.appId}`)}
            >
              Buy Now
            </Button>
            <div className={classes.prices}>
              <span className={classes.originalPrice}>$99</span>
              <span className={classes.price}>{formatPrice(prices[product.appId])}</span>
              <span className={classes.discount}>{getDiscount(prices[product.appId])}</span>
            </div>
          </div>
        </article>)}
      </section>
    </main>
    <Footer />
  </Layout>
}

export default Promo
